import { Score } from "@/components/utils"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerScale({ answer, question }: IAnswerProps) {
  const { type, meta } = question
  const scaleType = type == "scale" ? meta?.category : type
  const percent = scaleType == "percent"

  const value = answer?.value

  if (!value) return <NoAnswer />
  return (
    <Score
      value={value}
      fixed={!percent && value < 100}
      base={scaleType == "scale5" ? 5 : percent ? 100 : 10}
      shade={7}
    />
  )
}
